import { api } from './client'
import type { components } from './generated/schema'

export interface TeaGrade {
    id: string
    code: string
    name: string
    sort_order: number
    is_active: boolean
    created_at: string
    updated_at: string
    // Số lô đang dùng grade này (hydrated ở List, BE tính qua COUNT). FE
    // dùng để disable Delete + hiện tooltip lý do khi > 0. M-39: mỗi danh mục
    // chỉ điền cặp field của kho mình, cặp còn lại luôn 0.
    sorting_lots_count: number
    scenting_lots_count: number
    // Tồn (kg) của kho sở hữu danh mục, chỉ tính lô còn hàng — hydrated ở
    // List để bảng hiện được cột Tồn kho mà không phải gọi thêm một request
    // cho mỗi dòng. Như cặp count ở trên: field của kho kia luôn 0.
    sorting_stock: number
    scenting_stock: number
    // Loại chè tấm (M-74). Chỉ danh mục kho lấy hương có cờ; danh mục kho
    // phân loại luôn false.
    is_broken?: boolean
}

/** Tồn của một phân loại ở kho sở hữu danh mục, đã gộp mọi lô active còn
 *  hàng. */
export type TeaGradeStockItem = components['schemas']['TeaGradeStockItem']

/** Một lô còn tồn của phân loại. `occurred_at` là ngày nghiệp vụ: ngày tạo lô
 *  với kho phân loại, ngày lấy hương với kho lấy hương — `date_source` nói rõ
 *  khi ngày phải lùi về ngày tạo lô vì lô cũ không có phiếu mang ngày. */
export type TeaGradeStockLot = components['schemas']['TeaGradeStockLot']

export interface ListTeaGradesParams {
    is_active?: boolean
    /** Chỉ danh mục lấy hương: true = loại chè tấm, false = loại thường. */
    is_broken?: boolean
    search?: string
}

export interface CreateTeaGradeRequest {
    code: string
    name: string
    sort_order?: number
    is_active?: boolean
    is_broken?: boolean
}

export interface PatchTeaGradeRequest {
    code?: string
    name?: string
    sort_order?: number
    is_active?: boolean
    is_broken?: boolean
}

/** Kho sở hữu danh mục. M-39: mỗi kho một bảng riêng, cùng hình dạng. */
export type GradeKind = 'sorting' | 'scenting'

export function createGradeApi(basePath: '/tea-grades' | '/scenting-grades') {
    return {
        list: (params?: ListTeaGradesParams) =>
            api.get<TeaGrade[]>(basePath, {
                params: params as Record<
                    string,
                    string | number | boolean | undefined
                >,
            }),
        get: (id: string) => api.get<TeaGrade>(`${basePath}/${id}`),
        stock: (id: string) =>
            api.get<TeaGradeStockItem[]>(`${basePath}/${id}/stock`),
        stockLots: (id: string) =>
            api.get<TeaGradeStockLot[]>(`${basePath}/${id}/stock-lots`),
        create: (data: CreateTeaGradeRequest) =>
            api.post<TeaGrade>(basePath, data),
        patch: (id: string, data: PatchTeaGradeRequest) =>
            api.patch<TeaGrade>(`${basePath}/${id}`, data),
        remove: (id: string) =>
            api.delete<{ status: string }>(`${basePath}/${id}`),
    }
}

/** Danh mục phân loại của kho phân loại. */
export const teaGradeApi = createGradeApi('/tea-grades')
/** Danh mục phân loại của kho lấy hương (bảng riêng từ M-39). */
export const scentingGradeApi = createGradeApi('/scenting-grades')

export function gradeApiFor(kind: GradeKind) {
    return kind === 'scenting' ? scentingGradeApi : teaGradeApi
}
